<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header text-center">
          <i class="fas fas-align-justify"></i>
          <h3>Template Details</h3>
          <div class="row justify-content-center mt-4 mb-3">
            <div class="col-4 text-center">
              <h5>You have chosen: {{ template?.description }}</h5>
              <div class="row">
                <img class="template-img" [src]="createTemplateImage(template?.planData)">
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form [formGroup]="quoteForm" class="needs-validation mt-4" novalidate>
            <!-- Row 1 -->
            <div class="row g-3">
              <div class="col-3">
                <label class="col-form-label d-block">Deck Colour*
                  <ng-select
                    [items]="deckColours"
                    bindLabel="text"
                    bindValue="text"
                    [appearance]="'outline'"
                    formControlName="deckColour"
                    [required]="true">
                  </ng-select>
                </label>
                <div *ngIf="f.deckColour.invalid && (deckColourIdSubmitted || f.deckColour.touched)"
                     class="mt-1 text-danger">
                  <div *ngIf="f.deckColour.errors?.['required']">
                    Deck Colour is required.
                  </div>
                </div>
              </div>
              <div class="col-3">
                <label class="col-form-label d-block">Balustrade Colour*
                  <ng-select
                    [items]="balustradeColours"
                    bindLabel="text"
                    bindValue="text"
                    [appearance]="'outline'"
                    formControlName="balustradeColour"
                    [required]="true">
                  </ng-select>
                </label>
                <div *ngIf="f.balustradeColour.invalid && (balustradeColourIdSubmitted || f.balustradeColour.touched)"
                     class="mt-1 text-danger">
                  <div *ngIf="f.balustradeColour.errors?.['required']">
                    Balustrade Colour is required.
                  </div>
                </div>
              </div>
              <div class="col">
                <label class="col-form-label d-block">Park*
                  <ng-select
                    [items]="parks"
                    bindLabel="custName"
                    bindValue="id"
                    [appearance]="'outline'"
                    formControlName="customerId"
                    (blur)="quoteForm.get('customerId')?.markAsTouched()"
                    [required]="true">
                  </ng-select>
                </label>
                <div *ngIf="f.customerId.invalid && (customerIdSubmitted || f.customerId.touched)"
                     class="mt-1 text-danger">
                  <div *ngIf="f.customerId.errors?.['required']">
                    Park is required.
                  </div>
                </div>
              </div>
              <div class="col-3">
                <labeled-input [required]="true" [name]="'Plot'" [formName]="'plot'"
                               [form]="quoteForm" [type]="'text'" [class]="'form-control'"></labeled-input>
              </div>
            </div>

            <!-- Row 3 -->
            <div class="row g-3">
              <div class="col-4">
                <labeled-input [required]="true" [name]="'Customer Name'"
                               [formName]="'customerName'" [form]="quoteForm" [type]="'text'"
                               [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-4">
                <labeled-input [required]="true" [name]="'Customer Email'"
                               [formName]="'customerEmail'" [form]="quoteForm" [type]="'text'"
                               [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-4">
                <labeled-input [required]="true" [name]="'Customer Phone'"
                               [formName]="'customerPhone'" [form]="quoteForm" [type]="'text'"
                               [class]="'form-control'"></labeled-input>
              </div>
            </div>

            <!-- Comments -->
            <div class="row g-3">
              <div class="col">
                <labeled-input [name]="'Comments'" [formName]="'comments'"
                               [form]="quoteForm" [type]="'text'" [class]="'form-control'"></labeled-input>
              </div>
            </div>

            <!-- Button -->
            <div class="row">
              <div class="col d-flex justify-content-end">
                <button type="button" class="btn btn-success"
                        [swal]="{title: 'Prices could change when survey is carried out', showDenyButton: true}"
                        (confirm)="this.createQuote()">
                  Create Quote
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
